export const RNRenderer = {
  findHostInstance_DEPRECATED: _ref => null
};
//# sourceMappingURL=RNRenderer.web.js.map